import { useState } from 'react';
import { api, setToken } from '../shared/api.ts';

function defaultName(): string {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua)) return 'iPhone';
  if (/Macintosh/.test(ua)) return 'Mac browser';
  if (/Android/.test(ua)) return 'Android';
  return 'Browser';
}

/** Shown until this browser holds a device token. Nothing else is reachable. */
export function PairGate({ onPaired }: { onPaired: () => void }): React.JSX.Element {
  const [code, setCode] = useState('');
  const [name, setName] = useState(defaultName());
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent): Promise<void> => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const result = await api.pair(code.trim(), name.trim() || defaultName(), 'browser');
      setToken(result.token, result.device.name);
      onPaired();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Pairing failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="gate">
      <form className="gate__form" onSubmit={(e) => void submit(e)}>
        <label className="gate__label" htmlFor="pair-code">
          Pairing code
        </label>
        <input
          id="pair-code"
          className="input gate__code mono"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          autoCapitalize="characters"
          autoCorrect="off"
          spellCheck={false}
          placeholder="XXXX-XXXX"
          autoFocus
        />

        <label className="gate__label" htmlFor="pair-name">
          Device name
        </label>
        <input
          id="pair-name"
          className="input"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        {error ? <p className="gate__error mono">{error}</p> : null}

        <button type="submit" className="button button--primary" disabled={busy || code.trim().length < 8}>
          {busy ? 'Pairing…' : 'Pair'}
        </button>
      </form>
    </main>
  );
}
